import { ArrowLeftOutlined } from "@ant-design/icons";
import { FC } from "react";

import { Loc } from "@app/shared/ui/Loc";

import styles from "./VoiceRecordCancel.module.scss";

type Props = {
  cancelProgress: number;
  locked: boolean;
  recording: boolean;
};

export const VoiceRecordTouchSlideToCancel: FC<Props> = ({
  cancelProgress,
  locked,
  recording,
}) => {
  return (
    <div
      className={styles.voice_record_cancel}
      data-locked={locked}
      data-recording={recording}
      data-percent={cancelProgress}
      style={{
        opacity:
          cancelProgress === 0 ? 1 : 0.9 * ((100 - cancelProgress) / 100),
        marginRight: cancelProgress === 0 ? 0 : 80 * (cancelProgress / 100),
      }}
    >
      <ArrowLeftOutlined />
      <Loc
        word="Comment.voice.cancel.touch.help"
        default="Slide to cancel"
        className="text-placeholder"
      />
    </div>
  );
};
